import { SharedFileRequestContextType } from "@wingspanhq/wingspan-api-sdk";

export function selectorIsSharedFileResumeContext(
  contextType: SharedFileRequestContextType | undefined
): boolean {
  return !!contextType && contextType === SharedFileRequestContextType.RESUME;
}
